import { gql } from '@apollo/client';

const CREATE_PROPERTY = gql`
mutation CreateProperty($property: VrboPropertyInput!) {
    createProperty(property: $property) {
        ... on VrboProperty {
            listingTriad,
            expediaId,
            isCreatedByInternalUser,
            listingUrl
        }
        ... on ResponseRedirect {
            isRedirect,
            route
        }
    }
}
`;

export {
    // eslint-disable-next-line import/prefer-default-export
    CREATE_PROPERTY
};
